export default function GlcodeRenderer({ glCode }) {
    // GL codes have multiple parts, the glCode itself is an object
    const code = typeof glCode === 'object' ? glCode : {};

    return (
        <span className="glcode">
            {Object.entries(code).map(([section, v]) => {
                return (
                    <div key={section}>
                        <span style={{ fontSize: '80%' }}>{section}: </span>
                        <span className="glcodeSectionValue">{`${v}`}</span>
                    </div>
                );
            })}
        </span>
    );
}
